module.exports = __webpack_public_path__ + "static/media/Imprint_en.35051321.md";